import { render } from "./ExitModal.vue?vue&type=template&id=33f2661c&scoped=true"
import script from "./ExitModal.vue?vue&type=script&lang=js"
export * from "./ExitModal.vue?vue&type=script&lang=js"

import "./ExitModal.vue?vue&type=style&index=0&id=33f2661c&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33f2661c"]])

export default __exports__